<template>
  <div>
    <Header />

    <main class="app-content">
      <div class="app-title">
        <div>
          <h1
            style="
    display: flex;
    justify-content: center;
    align-items: center;
"
          >
            <i></i>SAHALAR &emsp; <br />
            <span style="background-color: #f77070; border-radius: 14px;"
              >0-25% => Kırmızı</span
            >&emsp;<span style="background-color: #ff9900; border-radius: 14px;"
              >26-55% => Turuncu</span
            >&emsp;<span style="background-color: #f4ff2d; border-radius: 14px;"
              >56-75% => Sarı</span
            >&emsp;<span style="background-color: #76f118; border-radius: 14px;"
              >76-99% => Yeşil</span
            >
            
          </h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">SAHALAR</a></li>
        </ul>
      </div>
      <div class="row">
        <div
          class="col-lg-12 col-md-12 justify-content-md-center rowHomepage"
        >
          <div
            v-for="(item, index) in sahalar"
            :key="index"
            class="col-md-3 col-lg-3"
            style="margin-bottom: 22px; height:110px"
            v-if="sahalar[index].isyuzdesi <100"
          >
            <div
            v-if="sahalar[index].reg_date == nowdate - 1 "
              style="
            background-color: rgb(120, 211, 167);
            /* display: flex; */
            display: -webkit-box;
            justify-content: center;
            align-items: center;
          "
              class="tileHomepage"
            >
              <div class="about-content">
                <div>
                  <p
                    v-if="
                      sahalar[index].isyuzdesi <= 25 &&
                        sahalar[index].isyuzdesi >= 0
                    "
                    @click="routePage(item)"
                    id="kirmizi"
                  >
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}% 
                 
                  </p>
                  <p
                    v-if="
                      sahalar[index].isyuzdesi <= 55 &&
                        sahalar[index].isyuzdesi >= 26
                    "
                    @click="routePage(item)"
                    id="turuncu"
                  >
                  {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}% 
                  </p>
                  <p
                    v-if="
                      sahalar[index].isyuzdesi <= 75 &&
                        sahalar[index].isyuzdesi >= 56
                    "
                    @click="routePage(item)"
                    id="sari"
                  >
                  {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}% 
                  </p>
                  <p
                    v-if="
                      sahalar[index].isyuzdesi <= 99 &&
                        sahalar[index].isyuzdesi >= 76
                    "
                    @click="routePage(item)"
                    id="yesil"
                  >
                  {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}% 
                  </p>
             
                </div>
              </div>
            </div>
<!-- false -->

            <div
            v-else
              style="
            background-color: rgb(221, 221, 221);
            display: flex;
            justify-content: center;
            align-items: center;
          "
              class="tileHomepage"
            >
              <div class="about-content">
                <div>
                  <p
                    v-if="
                      sahalar[index].isyuzdesi <= 25 &&
                        sahalar[index].isyuzdesi >= 0
                    "
                    @click="routePage(item)"
                    id="kirmizi"
                  >
                  {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}% 
                  </p>
                  <p
                    v-if="
                      sahalar[index].isyuzdesi <= 55 &&
                        sahalar[index].isyuzdesi >= 26
                    "
                    @click="routePage(item)"
                    id="turuncu"
                  >
                  {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}% 
                  </p>
                  <p
                    v-if="
                      sahalar[index].isyuzdesi <= 75 &&
                        sahalar[index].isyuzdesi >= 56
                    "
                    @click="routePage(item)"
                    id="sari"
                  >
                  {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}% 
                  </p>
                  <p
                    v-if="
                      sahalar[index].isyuzdesi <= 99 &&
                        sahalar[index].isyuzdesi >= 76
                    "
                    @click="routePage(item)"
                    id="yesil"
                  >
                  {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}% 
                  </p>
          
                </div>
              </div>
            </div>
            </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      sahalar: [],
      nowdate: "",
      nowyear: "",
      nowmonth: "",
      getFullYearAll: "",
      token: "",
    };
  },
  methods: {
    routePage: function(item) {
      window.location.href = "#/yeodetail?id="+ item.id + item.keycode;
    },
  },
  mounted() {
    let date = new Date();
    this.nowdate = date.getDate()
    this.nowyear = date.getFullYear()
    this.nowmonth = date.getMonth()
    this.getFullYearAll = this.nowdate + "." + this.nowmonth + "." + this.nowyear;
  //  console.log(this.nowdate);
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    var admin_token = localStorage.getItem("admin_token");
    var id = localStorage.getItem("id");
    if (!token) {
      if(!admin_token){
        this.$router.push("/");
      }else{
        console.log("deneme")
      }
      
    }
    var datas = {
      id: id,
    };
    var url = store.state.base_url + "AslanSahalar/yeoGetAllSaha.php?key=123";
    axios
    .post(url, JSON.stringify(datas)).then((response) => {
        this.sahalar = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });

    setTimeout(function() {
    //  alert("Sayfa yenilendi");
      window.location.reload(1);
    }, 2500000);
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>

<style>
#kirmizi {
  border-radius: 15px 50px;
  background-color: #f77070;
  text-align: center;
  font-size: 25px;
}
#turuncu {
  border-radius: 15px 50px;
  background-color: #ff9900;
  text-align: center;
  font-size: 25px;
}
#sari {
  border-radius: 15px 50px;
  background-color: #f4ff2d;
  text-align: center;
  font-size: 25px;
}
#yesil {
  border-radius: 15px 50px;
  background-color: #76f118;
  text-align: center;
  font-size: 25px;
}
#mavi {
  border-radius: 15px 50px;
  background-color: #19c6f1;
  text-align: center;
  font-size: 25px;
}
#pid1:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}
#pid2:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}
#pid3:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}
#pid4:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}
.col-md-3 {
  /* Burada, mobil ekranlarda 1 sütun genişliği belirleyebilirsiniz */
  width: 100%;
}

.rowHomepage {
  /* Satırların taşma yapmaması için esnek ayarlar yapabilirsiniz */
  display: flex;
  flex-wrap: wrap;
  /* Satırların alt alta yerleşmesini sağlar */
  justify-content: center;
  /* İçerikleri yatay olarak ortalar */
}
</style>



// WEBPACK FOOTER //
// src/components/YeoSahalar.vue